document.addEventListener("DOMContentLoaded", () => {
    // =============================================
    // 1. STATE MANAGEMENT
    // =============================================
    const state = {
        mainSize: "10x7 Aluminum",
        borderColor: "Gloss Black",
        backgroundColor: "Gloss White",
        text1: "",
        text2: "",
        font1: "Anton",
        font2: "Anton",
        font_color1: "Black",
        font_color2: "Black",
        price: 0,
        artworkImage: null,
    };

    // =============================================
    // 2. PRICE VARIANTS
    // =============================================
    const PRICE_VARIANTS = {
        mainSize: [
            { value: "10x7 Aluminum", price: 16.99 },
            { value: "10x7 Decal Sticker", price: 9.99 },
            { value: "10x14 Aluminum", price: 20.99 },
            { value: "12x18 Aluminum", price: 30.99 },
            { value: "12x18 Reflective Aluminum", price: 35.99 },
            { value: "18x24 Aluminum", price: 67.99 },
            { value: "18x24 Reflective Aluminum", price: 79.99 },
            { value: "24x30 Aluminum", price: 99.99 },
            { value: "24x30 Reflective Aluminum", price: 114.99 },
        ]
    };

    // Color mappings for border, background, and text
    const COLOR_MAPPINGS = {
        "Gloss Black": "#000000",
        "Gloss White": "#FFFFFF",
        "Ice Blue": "#21B3DA",
        "Sky Blue": "#0498DE",
        "Azure Blue": "#0797DE",
        "Cobalt Blue": "#1A2A99",
        "Dark Blue": "#242D72",
        "Steel Blue": "#01084E",
        "Brimestone Yellow": "#FDF809",
        "Yellow": "#FEDC01",
        "Signal Yellow": "#FFB600",
        "Golden Yellow": "#FFB401",
        "Pastel Orange": "#FF7111",
        "Orange": "#FE7306",
        "Orange Red": "#F63700",
        "Red": "#C70304",
        "Dark Red": "#960B04",
        "Burgundy": "#5A121D",
        "Light Gray": "#E3DFE0",
        "Dark Gray": "#818181",
        "Mint": "#22D095",
        "Turquoise": "#02979B",
        "Lime Tree Green": "#52B12F",
        "Yellow Green": "#4A9E2C",
        "Green": "#049049",
        "Forest Green": "#04370C",
        "Dark Green": "#012906",
        "Lilac": "#DC89A5",
        "Lavender": "#904E8B",
        "Violet": "#721A44",
        "Purple": "#711953",
        "Purple Red": "#8C112E",
        "Soft Pink": "#E66B87",
        "Bright Pink": "#F62B56",
        "Silver Gray Metallic": "#A4A7AC",
        "Gold metallic": "#C0B452",
        "Copper Metallic": "#822803",
        "Cream": "#FBDC81",
        "Beige": "#D8BD78",
        "Light Brown": "#C16B38",
        "Nut Brown": "#A93F18",
        "Brown": "#350C06",
    };

    let previousSize = null;

    // =============================================
    // 3. HELPER FUNCTIONS
    // =============================================
    function show(el) {
        if (el) el.style.display = "";
    }

    function hide(el) {
        if (el) el.style.display = "none";
    }

    function animatePriceChange(targetElement, start, end, duration = 500) {
        let startTime = null;
        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const currentValue = start + (end - start) * progress;
            targetElement.textContent = currentValue.toFixed(2);
            if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }

    function priceOf(groupKey, chosenValue) {
        if (!chosenValue) return 0;
        const list = PRICE_VARIANTS[groupKey] || [];
        const found = list.find((item) => item.value === chosenValue);
        return found ? found.price : 0;
    }

    function debounce(func, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => func(...args), delay);
        };
    }

    function dataURLtoFile(dataurl, filename) {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    function disableBodyScroll() {
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.dataset.scrollY = scrollY; // save position
    }

    function enableBodyScroll() {
        const scrollY = document.body.dataset.scrollY || 0;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        window.scrollTo(0, parseInt(scrollY, 10));
        document.body.removeAttribute('data-scrollY');
    }

    // =============================================
    // 4. SIZE SELECTION
    // =============================================
    function setupSizeSelection() {
        const sizeWrapper = document.querySelector("#size-variant .sticker-variants__list");
        const artworkVariant = document.getElementById("artwork-variant");
        const uploadArtbox = document.getElementById("upload-artbox");
        const previewBox = document.getElementById("preview-box");
        if (!sizeWrapper) return;
        sizeWrapper.addEventListener("click", (event) => {
            const selected = event.target.closest(".sticker-variant");
            if (!selected || selected.classList.contains("active")) return;
            sizeWrapper.querySelectorAll(".sticker-variant").forEach((el) => {
                el.classList.remove("active");
            });
            selected.classList.add("active");
            state.mainSize = selected.dataset.size;

            artworkVariant.style.display = "block";

            if (previousSize === selected.dataset.size && state.artworkImage) {
                uploadArtbox.style.display = "none";
                previewBox.style.display = "block";
            } else {
                uploadArtbox.style.display = "block";
                previewBox.style.display = "none";
            }
            sizeWrapper.closest(".pcs-variant").classList.add("variant-picked");
            recalcPrice();
            if (designer) designer.updateSize(state.mainSize);
        });
    }

    // =============================================
    // 5. DROPDOWN HANDLING
    // =============================================
    function initDropdownDefaults() {
        document.querySelectorAll(".select-dropdown").forEach((dd) => {
            const preSel = dd.querySelector("li.selected");
            const header = dd.querySelector(".selected-text");
            if (preSel && header) {
                header.textContent = preSel.textContent;
                const stateKey = dd.dataset.stateKey;
                if (stateKey && preSel.dataset.value) {
                    state[stateKey] = preSel.dataset.value;
                }
            }
        });
    }

    function dropdownClickHandler(evt) {
        const dropdown = evt.target.closest(".select-dropdown");
        if (!dropdown) {
            document.querySelectorAll(".dropdown-options").forEach((list) => hide(list));
            return;
        }
        const list = dropdown.querySelector(".dropdown-options");
        const header = dropdown.querySelector(".selected-text");
        const stateKey = dropdown.dataset.stateKey;
        const optionEl = evt.target.closest("li[data-value]");
        document.querySelectorAll(".dropdown-options").forEach((other) => {
            if (other !== list) hide(other);
        });
        if (optionEl) {
            const value = optionEl.dataset.value;
            if (!value) return;
            list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
            optionEl.classList.add("selected");
            header.textContent = optionEl.textContent;
            if (header.parentElement.classList.contains("color-dropdown")) {
                header.style.setProperty("--swatch", COLOR_MAPPINGS[value]);
            }
            dropdown.classList.add("variant-picked");
            // Apply font class to selected-text for font dropdowns
            if (stateKey === "font1" || stateKey === "font2") {
                header.classList.forEach((cls) => {
                    if (cls.startsWith('font-')) header.classList.remove(cls);
                });
                optionEl.classList.forEach((cls) => {
                    if (cls.startsWith('font-')) header.classList.add(cls);
                });
            }
            if (stateKey) {
                state[stateKey] = value;
                const targetElement = document.getElementById(`${stateKey}-select`);
                if (targetElement) {
                    const customEvent = new Event("change");
                    customEvent.target = { value: value };
                    targetElement.dispatchEvent(customEvent);
                }
                if (designer) {
                    switch (stateKey) {
                        case "borderColor":
                            designer.updateBorderColor(value);
                            break;
                        case "backgroundColor":
                            designer.updateBackgroundColor(value);
                            break;
                        case "font1":
                            designer.updateFont1(value);
                            break;
                        case "font2":
                            designer.updateFont2(value);
                            break;
                        case "font_color1":
                            designer.updateFontColor1(value);
                            break;
                        case "font_color2":
                            designer.updateFontColor2(value);
                            break;
                    }
                }
            }
            hide(list);
            return;
        }
        list.style.display = list.style.display === "block" ? "none" : "block";
    }

    // =============================================
    // 6. CUSTOM TEXT INPUT
    // =============================================
    function handleTextInput1() {
        const input = document.getElementById("text-input-1");
        const counter = document.getElementById("text-input-1-char-count");
        const error = document.getElementById("text-input-1-error-bar");
        const wrapper = input?.parentElement;
        if (!input || !counter || !error || !wrapper) return;
        const MAX = 200;
        const refresh = () => {
            if (input.value.length > MAX) {
                input.value = input.value.slice(0, MAX);
            }
            state.text1 = input.value;
            const remaining = MAX - input.value.length;
            counter.textContent = `${remaining} character(s) left`;
            if (input.value.trim()) {
                error.style.display = "none";
                wrapper.classList.add("variant-picked");
            } else {
                wrapper.classList.remove("variant-picked");
            }
            if (designer) {
                designer.updateText1(input.value);
            }
        };
        input.addEventListener("input", refresh);
        refresh();
    }

    function handleTextInput2() {
        const input = document.getElementById("text-input-2");
        const counter = document.getElementById("text-input-2-char-count");
        const error = document.getElementById("text-input-2-error-bar");
        const wrapper = input?.parentElement;
        if (!input || !counter || !error || !wrapper) return;
        const MAX = 200;
        const refresh = () => {
            if (input.value.length > MAX) {
                input.value = input.value.slice(0, MAX);
            }
            state.text2 = input.value;
            const remaining = MAX - input.value.length;
            counter.textContent = `${remaining} character(s) left`;
            if (input.value.trim()) {
                error.style.display = "none";
                wrapper.classList.add("variant-picked");
            } else {
                wrapper.classList.remove("variant-picked");
            }
            if (designer) {
                designer.updateText2(input.value);
            }
        };
        input.addEventListener("input", refresh);
        refresh();
    }

    // =============================================
    // 7. ARTWORK UPLOAD
    // =============================================
    function setupArtworkUpload() {
        const artbox = document.getElementById("upload-artbox");
        const previewBox = document.getElementById("preview-box");
        const mainVariants = document.getElementById("main-variants");
        const deleteBannerImage = document.getElementById("delete-banner-image");
        const uploadArtwork = document.getElementById("upload-artwork");

        if (!artbox || !previewBox || !mainVariants || !deleteBannerImage) {
            console.error("Required elements for artwork upload are missing");
            return;
        }

        // Create file input if not present
        if (!uploadArtwork) {
            const fileInput = document.createElement("input");
            fileInput.type = "file";
            fileInput.id = "upload-artwork";
            fileInput.accept = ".jpg,.jpeg,.png,.svg,.webp,.pdf,.ai,.eps,.tiff";
            fileInput.style.display = "none";
            artbox.querySelector(".upload-file-box label").appendChild(fileInput);
        }

        const fileInput = document.getElementById("upload-artwork");
        if (!fileInput) return;

        fileInput.addEventListener("change", (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const allowedTypes = [
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/webp",
                "image/svg+xml",
                "application/pdf",
                "image/tiff",
                "application/postscript",
            ];
            const ext = file.name.split(".").pop().toLowerCase();
            const isNonEditable = ["pdf", "ai", "eps", "tiff"].includes(ext);

            if (!allowedTypes.includes(file.type) && !["ai", "eps"].includes(ext)) {
                designer.showError("Please upload a valid image file (.jpg, .jpeg, .png, .svg, .webp, .pdf, .ai, .eps, .tiff)");
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                const img = document.getElementById("preview-image");
                if (isNonEditable) {
                    const FORMAT_ICONS = {
                        pdf: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/pdf-file.png",
                        ai: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/ai-file.png",
                        eps: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/eps-file.png",
                        tiff: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/tif-file.png",
                    };
                    img.src = FORMAT_ICONS[ext] || e.target.result;
                    previewBox.classList.add("non-editable-image");
                    document.getElementById("btnEditImage").style.display = "none";
                } else {
                    img.src = e.target.result;
                    previewBox.classList.remove("non-editable-image");
                    document.getElementById("btnEditImage").style.display = "";
                }
                artbox.style.display = "none";
                previewBox.style.display = "block";
                mainVariants.classList.add("active");
                state.artworkImage = file;
                const [widthInch, heightInch] = state.mainSize
                    .split("x")
                    .map((s) => s.trim().split(" ")[0]);
                document.getElementById("width-inch").textContent = `${widthInch}"`;
                document.getElementById("height-inch").textContent = `${heightInch}"`;
                previousSize = state.mainSize;
                designer.updateFinishButtonState();

                if (!isNonEditable && designer) {
                    fabric.Image.fromURL(
                        URL.createObjectURL(file),
                        (imgObj) => {
                            if (!designer.canvas || !designer.clipPath) return;
                            if (designer.artwork) designer.canvas.remove(designer.artwork);
                            const clipWidth = designer.clipPath.width;
                            const clipHeight = designer.clipPath.height;
                            const scaleFactor = Math.min(
                                (clipWidth * 0.5) / imgObj.width,
                                (clipHeight * 0.5) / imgObj.height
                            );
                            const centerX = designer.canvas.getWidth() / 2;
                            const centerY = designer.canvas.getHeight() / 2;
                            imgObj.set({
                                scaleX: scaleFactor,
                                scaleY: scaleFactor,
                                originX: "center",
                                originY: "center",
                                left: centerX,
                                top: centerY,
                                selectable: true,
                                evented: true,
                                hasControls: true,
                                hasBorders: true,
                            });
                            imgObj.setCoords();
                            designer.canvas.add(imgObj);
                            designer.artwork = imgObj;
                            designer.canvas.renderAll();
                            designer.updateFinishButtonState();
                        },
                        { crossOrigin: "anonymous" }
                    );
                }
            };
            reader.onerror = () => {
                designer.showError("Error reading file. Please try again.");
                state.artworkImage = null;
            };
            reader.readAsDataURL(file);
        });

        deleteBannerImage.addEventListener("click", () => {
            if (designer.artwork) designer.canvas.remove(designer.artwork);
            designer.artwork = null;
            state.artworkImage = null;
            artbox.style.display = "block";
            previewBox.style.display = "none";
            mainVariants.classList.remove("active");
            const previewImage = document.getElementById("preview-image");
            if (previewImage) previewImage.src = "";
            fileInput.value = "";
            designer.canvas.renderAll();
            designer.updateFinishButtonState();
        });
    }

    // =============================================
    // 8. PRICE CALCULATION
    // =============================================
    function recalcPrice() {
        let total = priceOf("mainSize", state.mainSize) || 0;
        total = Math.round(total * 100) / 100;
        const priceEl = document.getElementById("pcs-final-price");
        if (priceEl) {
            const prevValue = parseFloat(priceEl.textContent) || 0;
            if (prevValue !== total) {
                animatePriceChange(priceEl, prevValue, total);
            }
        }
        state.price = total;
    }

    // =============================================
    // 9. FORM VALIDATION
    // =============================================
    function validateForm() {
        let firstInvalid = null;
        function toggleError(id, show, message = "") {
            const bar = document.getElementById(id);
            if (!bar) return;
            if (message) bar.textContent = message;
            bar.style.display = show ? "block" : "none";
            const variantBox = bar.closest(".pcs-variant");
            if (variantBox) variantBox.classList.toggle("has-error", show);
            if (show && !firstInvalid) firstInvalid = variantBox || bar;
        }
        toggleError("size-error-bar", !state.mainSize, "Please select a size.");
        toggleError(
            "text-input-1-error-bar",
            !state.text1 && !state.text2 && !state.artworkImage,
            "Please enter Text #1, Text #2, or upload artwork."
        );
        toggleError(
            "text-input-2-error-bar",
            !state.text1 && !state.text2 && !state.artworkImage,
            "Please enter Text #1, Text #2, or upload artwork."
        );
        // Validate color selections
        const borderColorSelect = document.getElementById("border-color-select");
        if (borderColorSelect) {
            const sel = borderColorSelect.querySelector(".dropdown-options li.selected");
            if (sel) state.borderColor = sel.getAttribute("data-value") || "Gloss Black";
        }
        const backgroundColorSelect = document.getElementById("background-color-select");
        if (backgroundColorSelect) {
            const sel = backgroundColorSelect.querySelector(".dropdown-options li.selected");
            if (sel) state.backgroundColor = sel.getAttribute("data-value") || "Gloss White";
        }
        const textColor1Select = document.getElementById("text-color1-select");
        if (textColor1Select) {
            const sel = textColor1Select.querySelector(".dropdown-options li.selected");
            if (sel) state.font_color1 = sel.getAttribute("data-value") || "Black";
        }
        const textColor2Select = document.getElementById("text-color2-select");
        if (textColor2Select) {
            const sel = textColor2Select.querySelector(".dropdown-options li.selected");
            if (sel) state.font_color2 = sel.getAttribute("data-value") || "Black";
        }
        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
            return false;
        }
        return true;
    }

    // =============================================
    // 10. RESET FORM
    // =============================================
    function resetCalculatorForm() {
        state.mainSize = "10x7 Aluminum";
        state.borderColor = "Gloss Black";
        state.backgroundColor = "Gloss White";
        state.font1 = "Anton";
        state.font2 = "Anton";
        state.font_color1 = "Black";
        state.font_color2 = "Black";
        state.text1 = "";
        state.text2 = "";
        state.price = 0;
        state.artworkImage = null;

        // Reset size selection
        const sizeWrapper = document.querySelector("#size-variant .sticker-variants__list");
        if (sizeWrapper) {
            sizeWrapper.querySelectorAll(".sticker-variant").forEach((el) => {
                el.classList.toggle("active", el.dataset.size === "10x7 Aluminum");
            });
            sizeWrapper.closest(".pcs-variant").classList.remove("variant-picked");
        }

        // Reset color dropdowns
        [
            { id: "border-color-select", stateKey: "borderColor", defaultValue: "Gloss Black" },
            { id: "background-color-select", stateKey: "backgroundColor", defaultValue: "Gloss White" },
            { id: "text-color1-select", stateKey: "font_color1", defaultValue: "Gloss Black" },
            { id: "text-color2-select", stateKey: "font_color2", defaultValue: "Gloss Black" }
        ].forEach(({ id, stateKey, defaultValue }) => {
            const dropdown = document.getElementById(id);
            if (dropdown) {
                const list = dropdown.querySelector(".dropdown-options");
                const header = dropdown.querySelector(".selected-text");
                if (list && header) {
                    list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
                    const defaultOption = list.querySelector(`li[data-value="${defaultValue}"]`);
                    if (defaultOption) {
                        defaultOption.classList.add("selected");
                        header.textContent = defaultOption.textContent.trim();
                        // Reset the --swatch property for color dropdowns
                        if (dropdown.classList.contains("color-dropdown")) {
                            header.style.setProperty("--swatch", COLOR_MAPPINGS[defaultValue] || "#000000");
                        } else {
                            header.style.removeProperty("--swatch"); // Remove --swatch if not a color dropdown
                        }
                        state[stateKey] = defaultValue;
                        const customEvent = new Event("change");
                        customEvent.target = { value: defaultValue };
                        dropdown.dispatchEvent(customEvent);
                    }
                    hide(list);
                    dropdown.classList.remove("variant-picked");
                }
            }
        });

        // Reset text inputs
        const textInputs = [
            { id: "text-input-1", counterId: "text-input-1-char-count", stateKey: "text1" },
            { id: "text-input-2", counterId: "text-input-2-char-count", stateKey: "text2" }
        ];
        textInputs.forEach(({ id, counterId, stateKey }) => {
            const input = document.getElementById(id);
            const counter = document.getElementById(counterId);
            if (input) {
                input.value = "";
                state[stateKey] = "";
                if (counter) counter.textContent = "200 character(s) left";
                input.parentElement.classList.remove("variant-picked");
                if (designer) {
                    if (stateKey === "text1") designer.updateText1("");
                    else if (stateKey === "text2") designer.updateText2("");
                }
            }
        });

        // Reset font dropdowns
        ["font1-select", "font2-select"].forEach((id) => {
            const fontSelect = document.getElementById(id);
            if (fontSelect) {
                const list = fontSelect.querySelector(".dropdown-options");
                const header = fontSelect.querySelector(".selected-text");
                if (list && header) {
                    list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
                    const firstOption = list.querySelector("li[data-value]");
                    if (firstOption) {
                        firstOption.classList.add("selected");
                        header.textContent = firstOption.textContent.trim();
                        header.classList.forEach((cls) => {
                            if (cls.startsWith('font-')) header.classList.remove(cls);
                        });
                        firstOption.classList.forEach((cls) => {
                            if (cls.startsWith('font-')) header.classList.add(cls);
                        });
                        state[id === "font1-select" ? "font1" : "font2"] = firstOption.dataset.value;
                        const customEvent = new Event("change");
                        customEvent.target = { value: firstOption.dataset.value };
                        fontSelect.dispatchEvent(customEvent);
                    }
                    hide(list);
                    fontSelect.classList.remove("variant-picked");
                }
            }
        });

        // Reset artwork
        const uploadArtbox = document.getElementById("upload-artbox");
        const previewBox = document.getElementById("preview-box");
        const previewImage = document.getElementById("preview-image");
        const uploadArtwork = document.getElementById("upload-artwork");
        if (uploadArtbox) uploadArtbox.style.display = "block";
        if (previewBox) previewBox.style.display = "none";
        if (previewImage) previewImage.src = "";
        if (uploadArtwork) uploadArtwork.value = "";
        if (designer) designer.handleRemoveAll();

        // Clear errors
        document.querySelectorAll(".error-bar").forEach((el) => hide(el));
        document.querySelectorAll(".pcs-variant").forEach((el) => el.classList.remove("has-error"));

        recalcPrice();
    }

    // =============================================
    // 11. ADD TO CART
    // =============================================
    function setupApippaAddToCart() {
        const addToCartBtn = document.getElementById("pcs-add-to-cart");
        if (!addToCartBtn) return;
        addToCartBtn.addEventListener("click", async (e) => {
            e.preventDefault();
            if (!validateForm()) {
                console.log("Form invalid – fix the highlighted fields.");
                return;
            }
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add("loading");
            addToCartBtn.innerHTML = `
                <div class="pcs-loader"></div>
                <p class="pcs-message"></p>
                <div class="dot-falling"></div>
            `;
            const messageEl = addToCartBtn.querySelector(".pcs-message");
            const messages = ["Adding to cart", "GETTING THINGS READY"];
            let messageIndex = 0;
            let stopTypingLoop = false;
            const startTypingLoop = async () => {
                while (!stopTypingLoop) {
                    const message = messages[messageIndex % messages.length];
                    await typeText(messageEl, message);
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                    await deleteText(messageEl);
                    messageIndex++;
                }
            };
            startTypingLoop();
            const loadingBar = addToCartBtn.querySelector(".pcs-loader");
            let progress = 0;
            const target = 99;
            const interval = setInterval(() => {
                if (progress < 50) {
                    progress += 2;
                } else if (progress < 80) {
                    progress += (80 - progress) * 0.05;
                } else if (progress < target - 0.2) {
                    progress += (target - progress) * 0.05;
                } else {
                    progress = target - 0.01;
                    clearInterval(interval);
                }
                loadingBar.style.transform = `scaleX(${Math.floor(progress)}%)`;
            }, 80);
            try {
                const requestData = {
                    calculatorId: "37eec7fc6b2b4",
                    productId: 7721002303536,
                    properties: {
                        "Main Size": state.mainSize,
                        "Border Color": state.borderColor,
                        "Background Color": state.backgroundColor,
                        "Text #1": state.text1 || "",
                        "Text #2": state.text2 || "",
                        "Font #1": state.text1?.trim() ? state.font1 : "",
                        "Font #2": state.text2?.trim() ? state.font2 : "",
                        "Font Color #1": state.text1?.trim() ? state.font_color1 : "",
                        "Font Color #2": state.text2?.trim() ? state.font_color2 : "",
                        "Upload Image": state.artworkImage ? state.artworkImage : "",
                    }, 
                };
                console.log("Request Data: ", requestData);
                const variantRes = await fetch(
                    "https://api.custompricecalculator.com/api/v1/variant",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestData),
                    }
                );
                const variantId = await variantRes.json();
                const shopifyVariantId =
                    typeof variantId === "string"
                        ? variantId
                        : variantId?.variantId || variantId?.id;
                if (!shopifyVariantId) throw new Error("Invalid variant ID");

                const formData = new FormData();
                formData.append("id", shopifyVariantId);
                formData.append("quantity", 1);
                Object.entries(requestData.properties).forEach(([key, value]) => {
                    if (value instanceof File) {
                        formData.append(`properties[${key}]`, value);
                    } else {
                        formData.append(`properties[${key}]`, value);
                    }
                });

                const cartAddRes = await fetch("/cart/add.js", {
                    method: "POST",
                    body: formData,
                });
                const cartAddJson = await cartAddRes.json();
                if (!cartAddRes.ok) throw new Error("Failed to add to cart");

                localStorage.setItem(
                    `patched-cart-item-${cartAddJson.id}`,
                    JSON.stringify({
                        id: cartAddJson.id,
                        title: cartAddJson.product_title,
                        image: cartAddJson.image,
                        price: cartAddJson.price,
                    })
                );

                const timestamp = new Date().getTime();
                await new Promise((resolve) => setTimeout(resolve, 200));
                const sectionHtml = await fetch(
                    `/cart?section_id=mini-cart&t=${timestamp}`
                ).then((res) => res.text());
                const fakeDiv = document.createElement("div");
                fakeDiv.innerHTML = sectionHtml;
                const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;
                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer && miniCartHTML) {
                    cartDrawer.dispatchEvent(
                        new CustomEvent("cart:refresh", {
                            bubbles: true,
                            detail: {
                                cart: {
                                    items: [cartAddJson],
                                    item_count: 1,
                                    total_price: cartAddJson.final_price,
                                    original_total_price: cartAddJson.original_price,
                                    total_discount: 0,
                                    sections: { "mini-cart": miniCartHTML },
                                },
                                openMiniCart: true,
                            },
                        })
                    );
                }

                setTimeout(() => {
                    const lineItems = cartDrawer.querySelectorAll("line-item");
                    lineItems.forEach((lineItem) => {
                        const desktopPriceContainer = lineItem.querySelector(
                            ".line-item__price-list-container .price"
                        );
                        const mobilePriceContainer = lineItem.querySelector(
                            ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
                        );
                        if (!desktopPriceContainer && !mobilePriceContainer) return;
                        const priceText = (
                            desktopPriceContainer || mobilePriceContainer
                        ).textContent.trim();
                        const isFree = /Free|\$0\.00/.test(priceText);
                        let variantId;
                        const productLink = lineItem.querySelector("a[href*='?variant=']");
                        if (productLink?.href.includes("variant=")) {
                            variantId = productLink.href.split("variant=")[1].split("&")[0];
                        }
                        if (!variantId) {
                            const removeBtn = lineItem.querySelector(
                                "a[href*='/cart/change?id=']"
                            );
                            const removeHref = removeBtn?.getAttribute("href") || "";
                            const match = removeHref.match(/id=(\d+):/);
                            variantId = match?.[1];
                        }
                        if (isFree && variantId == shopifyVariantId) {
                            const matchingItem = { id: cartAddJson.id, price: cartAddJson.price };
                            if (matchingItem) {
                                const correctPrice = (matchingItem.price / 100).toFixed(2);
                                const imageWrapper = lineItem.querySelector(
                                    ".line-item__image-wrapper"
                                );
                                const productThumbnail = imageWrapper.querySelector(
                                    "img.line-item__image"
                                );
                                const productTitle = lineItem.querySelector(
                                    ".product-item-meta .product-item-meta__title"
                                );
                                if (!productThumbnail) {
                                    const imgSrc = document.querySelector(
                                        ".product__thumbnail-item .product__thumbnail img"
                                    )?.src;
                                    if (imgSrc) {
                                        imageWrapper.innerHTML += `
                                            <img src="${imgSrc}" alt="" srcset="${imgSrc}" width="1024" height="1024" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                                        `;
                                    }
                                }
                                if (productTitle.textContent.trim() === "") {
                                    productTitle.textContent = document.querySelector(
                                        ".product__info .product-meta__title"
                                    ).textContent;
                                }
                                const updatedPriceHTML = `
                                    <span class="visually-hidden">Sale price</span>
                                    $${correctPrice}
                                `;
                                if (desktopPriceContainer) {
                                    desktopPriceContainer.innerHTML = updatedPriceHTML;
                                }
                                if (mobilePriceContainer) {
                                    mobilePriceContainer.innerHTML = updatedPriceHTML;
                                }
                            }
                        }
                    });
                }, 300);

                setTimeout(async () => {
                    const cartJson = await fetch("/cart.js").then((res) => res.json());
                    const cartCountEl = document.querySelector("cart-count");
                    if (cartCountEl) {
                        cartCountEl.textContent = cartJson.item_count;
                    }
                }, 300);

                setTimeout(() => {
                    const drawerContent = document.querySelector(
                        "#shopify-section-mini-cart .drawer__content"
                    );
                    if (!drawerContent) return;
                    const confetti = document.createElement("dotlottie-player");
                    confetti.className = "mini-cart-lottie";
                    confetti.src =
                        "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
                    confetti.setAttribute("background", "transparent");
                    confetti.setAttribute("speed", "1");
                    confetti.setAttribute("style", "width: 300px; height: 300px");
                    confetti.setAttribute("autoplay", "");
                    drawerContent.prepend(confetti);
                    setTimeout(() => {
                        confetti.remove();
                    }, 3000);
                }, 1000);
            } catch (err) {
                console.error("Apippa Add to Cart Error:", err);
                alert("There was a problem adding your item to the cart.");
            } finally {
                addToCartBtn.disabled = false;
                addToCartBtn.classList.remove("loading");
                addToCartBtn.innerHTML = "Add to Cart";
                stopTypingLoop = true;
                resetCalculatorForm();
            }
        });
    }

    // Text animation helpers
    function typeText(el, text, speed = 60) {
        return new Promise((resolve) => {
            let i = 0;
            const typeInterval = setInterval(() => {
                el.textContent += text[i];
                i++;
                if (i >= text.length) {
                    clearTimeout(typeInterval);
                    resolve();
                }
            }, speed);
        });
    }

    function deleteText(el, speed = 40) {
        return new Promise((resolve) => {
            const delInterval = setInterval(() => {
                el.textContent = el.textContent.slice(0, -1);
                if (el.textContent.length === 0) {
                    clearTimeout(delInterval);
                    resolve();
                }
            }, speed);
        });
    }

    // =============================================
    // 12. METAL SIGN DESIGNER CLASS
    // =============================================
    class MetalSignDesigner {
        constructor() {
            this.canvas = null;
            this.clipPath = null;
            this.text1 = null;
            this.text2 = null;
            this.artwork = null;
            this.snappingEnabled = true;
            this._ro = null;
            this.icons = {
                resizeLeft: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-left.webp",
                resizeRight: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-right.webp",
                resizeHorizontal: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-horizontal.webp",
                stackUp: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackup.webp",
                stackDown: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackdown.webp",
                rotate: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/rotate.webp"
            };
            this.init();
        }

        init() {
            const canvasContainer = document.getElementById("canvasContainer");
            if (!canvasContainer) {
                console.error("Canvas container not found");
                return;
            }
            canvasContainer.innerHTML = '<canvas id="metalSignCanvas"></canvas>';
            this.canvas = new fabric.Canvas("metalSignCanvas", {
                width: canvasContainer.offsetWidth,
                height: canvasContainer.offsetHeight,
                preserveObjectStacking: true,
                controlsAboveOverlay: true,
                selection: true,
            });
            this.setupCanvas();
            this.setupEventListeners();
            this.setupCustomControls();
            this.observeContainerResize(canvasContainer);
            this.updateCanvasSize();
            this.drawClipPath();
            this.updateFinishButtonState();
            this.setupArtworkUpload();
        }

        observeContainerResize(container) {
            const ro = new ResizeObserver(
                debounce(() => this.handleResize(), 120)
            );
            ro.observe(container);
            this._ro = ro;
        }

        setupCanvas() {
            if (!this.canvas) return;
            this.canvas.preserveObjectStacking = true;
            this.canvas.controlsAboveOverlay = true;
            this.canvas.selection = true;
        }

        setupEventListeners() {
            window.addEventListener(
                "resize",
                debounce(() => this.handleResize(), 300)
            );

            document.addEventListener("keydown", (e) => {
                const obj = this.canvas?.getActiveObject();
                if (!obj) return;
                const mod = e.ctrlKey || e.metaKey;

                if (mod && e.key === "]") {
                    const cur = this.canvas.getObjects().indexOf(obj);
                    const maxIdx = this._topCeilingIndex();
                    if (cur < maxIdx) this.canvas.bringForward(obj);
                    this._guardZ(obj);
                    e.preventDefault();
                } else if (mod && e.key === "[") {
                    const cur = this.canvas.getObjects().indexOf(obj);
                    const minIdx = this._bgTopIndex() + 1;
                    if (cur > minIdx) this.canvas.sendBackwards(obj);
                    this._guardZ(obj);
                    e.preventDefault();
                }
            });

            const getStartedBtn = document.getElementById("get-started-btn");
            if (getStartedBtn) {
                getStartedBtn.addEventListener("click", () => {
                    const designerTool = document.getElementById("designerTool");
                    if (designerTool) {
                        designerTool.classList.add("active");
                        disableBodyScroll();
                    }
                    if (this.artwork) this.canvas.remove(this.artwork);
                    this.artwork = null;
                    state.artworkImage = null;
                    const previewImage = document.getElementById("preview-image");
                    if (previewImage) previewImage.src = "";
                    this.canvas.renderAll();
                    this.updateFinishButtonState();
                    this.drawClipPath();
                });
            }

            const closeBtn = document.getElementById("designer-tool-close-btn");
            if (closeBtn) {
                closeBtn.addEventListener("click", () => {
                    const popup = document.getElementById("close-tool-popup");
                    if (popup) popup.classList.add("active");
                });
            }

            const cancelClose = document.getElementById("cancel-close-tool");
            if (cancelClose) {
                cancelClose.addEventListener("click", () => {
                    const popup = document.getElementById("close-tool-popup");
                    if (popup) popup.classList.remove("active");
                });
            }

            const confirmClose = document.getElementById("confirm-close-tool");
            if (confirmClose) {
                confirmClose.addEventListener("click", () => {
                    const popup = document.getElementById("close-tool-popup");
                    const designerTool = document.getElementById("designerTool");
                    if (popup) popup.classList.remove("active");
                    if (designerTool) {
                        designerTool.classList.remove("active");
                        enableBodyScroll();
                    }
                });
            }

            const toggleSnap = document.getElementById("toggleSnap");
            if (toggleSnap) {
                toggleSnap.addEventListener("change", (e) => {
                    this.snappingEnabled = e.target.checked;
                });
            }

            const btnEditImage = document.getElementById("btnEditImage");
            if (btnEditImage) {
                btnEditImage.addEventListener("click", () => {
                    const designerTool = document.getElementById("designerTool");
                    if (designerTool) {
                        designerTool.classList.add("active");
                        disableBodyScroll();
                    }
                });
            }

            document.querySelectorAll(".align-btn").forEach((btn) =>
                btn.addEventListener("click", (e) =>
                    this.alignObjects(e.currentTarget.dataset.align)
                )
            );

            document.querySelectorAll(".text-align-btn").forEach((btn) =>
                btn.addEventListener("click", (e) => {
                    const align = e.currentTarget.dataset.textAlign;
                    const active = this.canvas.getActiveObject();
                    if (active && (active.type === "text" || active.type === "textbox")) {
                        active.set("textAlign", align);
                        this.canvas.renderAll();
                    }
                })
            );

            const finishEditing = document.getElementById("finishEditing");
            if (finishEditing) {
                finishEditing.addEventListener("click", () => this.finishEditing());
            }

            const textInput1 = document.getElementById("text-input-1");
            if (textInput1) {
                textInput1.addEventListener("input", (e) => this.updateText1(e.target.value));
            }

            const textInput2 = document.getElementById("text-input-2");
            if (textInput2) {
                textInput2.addEventListener("input", (e) => this.updateText2(e.target.value));
            }

            const borderColorSelect = document.getElementById("border-color-select");
            if (borderColorSelect) {
                borderColorSelect.addEventListener("change", (e) => {
                    if (e.target.value) this.updateBorderColor(e.target.value);
                });
            }

            const backgroundColorSelect = document.getElementById("background-color-select");
            if (backgroundColorSelect) {
                backgroundColorSelect.addEventListener("change", (e) => {
                    if (e.target.value) this.updateBackgroundColor(e.target.value);
                });
            }

            const textColor1Select = document.getElementById("text-color1-select");
            if (textColor1Select) {
                textColor1Select.addEventListener("change", (e) => {
                    if (e.target.value) this.updateFontColor1(e.target.value);
                });
            }

            const textColor2Select = document.getElementById("text-color2-select");
            if (textColor2Select) {
                textColor2Select.addEventListener("change", (e) => {
                    if (e.target.value) this.updateFontColor2(e.target.value);
                });
            }

            const font1Select = document.getElementById("font1-select");
            if (font1Select) {
                font1Select.addEventListener("change", (e) => {
                    if (e.target.value) this.updateFont1(e.target.value);
                });
            }

            const font2Select = document.getElementById("font2-select");
            if (font2Select) {
                font2Select.addEventListener("change", (e) => {
                    if (e.target.value) this.updateFont2(e.target.value);
                });
            }

            this.canvas.on("selection:created", (e) => {
                if (e.selected && e.selected.length === 1) {
                    const t = e.selected[0];
                    if (t.type === "text" || t.type === "textbox") {
                        const tools = document.getElementById("text-align-tools");
                        if (tools) tools.style.display = "flex";
                    }
                }
            });

            this.canvas.on("selection:updated", (e) => {
                const tools = document.getElementById("text-align-tools");
                const onlyOne = e.selected && e.selected.length === 1;
                const isText = onlyOne && (e.selected[0].type === "text" || e.selected[0].type === "textbox");
                if (tools) tools.style.display = isText ? "flex" : "none";
            });

            this.canvas.on("selection:cleared", () => {
                const textAlignTools = document.getElementById("text-align-tools");
                if (textAlignTools) textAlignTools.style.display = "none";
            });

            this.canvas.on("object:moving", (e) => {
                if (!this.snappingEnabled || !this.clipPath) return;
                const obj = e.target;
                if (!obj) return;
                const threshold = 10;
                const cur = obj.getCenterPoint();
                const clipBR = this.clipPath.getBoundingRect(true);
                const clipCX = clipBR.left + clipBR.width / 2;
                const clipCY = clipBR.top + clipBR.height / 2;
                let targetCX = cur.x;
                let targetCY = cur.y;
                if (Math.abs(cur.x - clipCX) <= threshold) targetCX = clipCX;
                if (Math.abs(cur.y - clipCY) <= threshold) targetCY = clipCY;
                obj.setPositionByOrigin(new fabric.Point(targetCX, targetCY), "center", "center");
                obj.setCoords();
                this.canvas.requestRenderAll();
            });
        }

        setupCustomControls() {
            const preload = (src) =>
                new Promise((resolve, reject) => {
                    const img = new Image();
                    img.crossOrigin = "anonymous";
                    img.onload = () => resolve(img);
                    img.onerror = reject;
                    img.src = src;
                });

            Promise.all([
                preload(this.icons.resizeLeft),
                preload(this.icons.resizeRight),
                preload(this.icons.resizeHorizontal),
                preload(this.icons.stackUp),
                preload(this.icons.stackDown),
                preload(this.icons.rotate)
            ]).then(([resizeLeftImg, resizeRightImg, resizeHImg, stackUpImg, stackDownImg, rotateImg]) => {
                this.applyCustomCornerIcons(resizeLeftImg, resizeRightImg, resizeHImg, stackUpImg, stackDownImg, rotateImg);
            }).catch((e) => console.warn("Icon preload failed:", e));

            fabric.Object.prototype.transparentCorners = false;
            fabric.Object.prototype.cornerColor = "black";
            fabric.Object.prototype.borderColor = "black";
            fabric.Object.prototype.cornerStyle = "circle";
            fabric.Object.prototype.cornerStrokeColor = "black";
            fabric.Object.prototype.borderScaleFactor = 1;
        }

        applyCustomCornerIcons(iconLeft, iconRight, iconHorizontal, iconStackUp, iconStackDown, iconRotate) {
            const renderIcon = (icon) => function (ctx, left, top, _style, fabricObject) {
                const size = this.cornerSize || 24;
                ctx.save();
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle || 0));
                ctx.drawImage(icon, -size / 2, -size / 2, size, size);
                ctx.restore();
            };

            const setCtrl = (key, opts) => {
                const ctrl = fabric.Object.prototype.controls[key];
                if (ctrl) Object.assign(ctrl, opts);
            };

            const cornerSize = 25;
            setCtrl("tl", { render: renderIcon(iconLeft), cornerSize });
            setCtrl("tr", { render: renderIcon(iconRight), cornerSize });
            setCtrl("bl", { render: renderIcon(iconRight), cornerSize });
            setCtrl("br", { render: renderIcon(iconLeft), cornerSize });

            const midSize = 25;
            setCtrl("ml", { render: renderIcon(iconHorizontal), cornerSize: midSize });
            setCtrl("mr", { render: renderIcon(iconHorizontal), cornerSize: midSize });

            fabric.Object.prototype.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false });

            const self = this;

            const ICON_SIZE = 25;
            const OFFSET_X = 25;
            const OFFSET_Y = 12;
            const GAP_Y = 6;

            const makeTopRightControl = (name, order, iconImg, onClick) => {
                fabric.Object.prototype.controls[name] = new fabric.Control({
                    x: 0.5,
                    y: -0.5,
                    offsetX: OFFSET_X,
                    offsetY: OFFSET_Y + order * (ICON_SIZE + GAP_Y),
                    cornerSize: ICON_SIZE,
                    cursorStyle: "pointer",
                    render: renderIcon(iconImg),
                    mouseUpHandler: (_evt, transform) => {
                        const obj = transform.target;
                        if (!obj || !obj.canvas) return;
                        onClick(obj);
                        self._guardZ(obj);
                        obj.canvas.setActiveObject(obj);
                        obj.canvas.requestRenderAll();
                    }
                });
            };

            makeTopRightControl("bringFwd", 0, iconStackUp, (obj) => {
                const cur = obj.canvas.getObjects().indexOf(obj);
                const maxIdx = self._topCeilingIndex();
                if (cur < maxIdx) obj.canvas.bringForward(obj);
            });

            makeTopRightControl("sendBack", 1, iconStackDown, (obj) => {
                const cur = obj.canvas.getObjects().indexOf(obj);
                const minIdx = self._bgTopIndex() + 1;
                if (cur > minIdx) obj.canvas.sendBackwards(obj);
            });

            const ROTATE_SIZE = 26;
            const ROTATE_OFFSETY = -32;

            fabric.Object.prototype.controls.mtr = new fabric.Control({
                x: 0,
                y: -0.5,
                offsetY: ROTATE_OFFSETY,
                cornerSize: ROTATE_SIZE,
                cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
                actionHandler: fabric.controlsUtils.rotationWithSnapping,
                actionName: "rotate",
                render: renderIcon(iconRotate),
                withConnection: true,
                connectionStyle: { stroke: "#000", strokeWidth: 1 },
            });
        }

        _topCeilingIndex() {
            if (!this.canvas) return -1;
            return this.canvas.getObjects().length - 1;
        }

        _bgTopIndex() {
            if (!this.canvas) return -1;
            const objs = this.canvas.getObjects();
            let idx = -1;
            if (this.clipPath) idx = Math.max(idx, objs.indexOf(this.clipPath));
            return idx;
        }

        _guardZ(obj) {
            if (!this.canvas || !obj) return;
            const objs = this.canvas.getObjects();
            const bgTop = this._bgTopIndex();
            const topCap = this._topCeilingIndex();
            let cur = objs.indexOf(obj);
            if (bgTop >= 0 && cur <= bgTop) this.canvas.moveTo(obj, bgTop + 1);
            cur = objs.indexOf(obj);
            if (topCap >= 0 && cur > topCap) this.canvas.moveTo(obj, topCap);
            this.canvas.requestRenderAll();
        }

        handleResize() {
            if (!this.canvas) return;
            this.updateCanvasSize();
            this.drawClipPath();
            this.canvas.renderAll();
        }

        updateCanvasSize() {
            const container = document.getElementById("canvasContainer");
            if (!container || !this.canvas) return;

            const width = Math.max(1, container.clientWidth || 1);
            const small = window.matchMedia("(max-width: 640px)").matches;
            const parsedSize = this.parseSize(state.mainSize);
            const ratio = parsedSize.width / parsedSize.height;
            let height;
            if (small) {
                let base = Math.max(120, Math.round(width / ratio));
                const nearSquare = ratio >= 0.9 && ratio <= 1.1;
                const midSquare = ratio > 0.75 && ratio < 1.33;
                const shrink = nearSquare ? 0.82 : (midSquare ? 0.9 : 1);
                height = Math.round(base * shrink);
                const maxVH = Math.floor(window.innerHeight * 0.6);
                height = Math.min(height, maxVH);
            } else {
                height = Math.max(1, container.clientHeight || Math.round(width / ratio));
            }

            this.canvas.setDimensions({ width, height });
            this.canvas.calcOffset();
            this.canvas.renderAll();
        }

        parseSize(sizeStr) {
            if (!sizeStr) {
                console.warn("Size string is undefined, using default 10x7");
                sizeStr = "10x7 Aluminum";
            }
            const [widthStr, heightStr] = sizeStr.split("x");
            const width = parseFloat(widthStr);
            const height = parseFloat(heightStr);
            return { width, height };
        }

        mobileFillForRatio(ratio) {
            if (ratio >= 0.9 && ratio <= 1.1) return 0.88;
            if (ratio >= 1.6 || ratio <= 0.625) return 0.95;
            return 0.90;
        }

        hasContent() {
            return (
                (state.text1 && state.text1.trim()) ||
                (state.text2 && state.text2.trim()) ||
                state.artworkImage
            );
        }

        updateFinishButtonState() {
            const finishEditing = document.getElementById("finishEditing");
            if (finishEditing) {
                finishEditing.disabled = !this.hasContent();
            }
        }

        drawClipPath() {
            if (!this.canvas) return;

            const objects = [
                this.text1,
                this.text2,
                this.artwork,
            ].filter(Boolean);

            let oldWidth = 0, oldHeight = 0, oldLeft = 0, oldTop = 0;
            if (this.clipPath) {
                oldWidth = this.clipPath.width;
                oldHeight = this.clipPath.height;
                oldLeft = this.clipPath.left;
                oldTop = this.clipPath.top;
            }

            this.canvas.clear();
            this.canvas.clipPath = null;

            const parsedSize = this.parseSize(state.mainSize);
            const ratio = parsedSize.width / parsedSize.height;
            const small = window.matchMedia("(max-width: 640px)").matches;
            const fill = small ? this.mobileFillForRatio(ratio) : 0.8;
            const maxWidth = this.canvas.getWidth() * fill;
            const maxHeight = this.canvas.getHeight() * fill;
            let clipWidth, clipHeight;
            if (ratio > maxWidth / maxHeight) {
                clipWidth = maxWidth;
                clipHeight = maxWidth / ratio;
            } else {
                clipHeight = maxHeight;
                clipWidth = maxHeight * ratio;
            }
            const centerX = this.canvas.getWidth() / 2;
            const centerY = this.canvas.getHeight() / 2;
            const scale = clipWidth / parsedSize.width;
            const radius_inches = 0.5; // Rounded corner radius in inches
            const stroke_inches = 0.125; // Border thickness in inches
            const strokeWidth = stroke_inches * scale;
            const rx = radius_inches * scale;

            // Create a rounded rectangle clipPath with background and border
            this.clipPath = new fabric.Rect({
                left: centerX - clipWidth / 2,
                top: centerY - clipHeight / 2,
                width: clipWidth,
                height: clipHeight,
                rx: rx,
                ry: rx,
                fill: COLOR_MAPPINGS[state.backgroundColor] || "#FFFFFF",
                stroke: COLOR_MAPPINGS[state.borderColor] || "#000000",
                strokeWidth: strokeWidth,
                selectable: false,
                evented: false,
            });
            this.canvas.add(this.clipPath);

            const hasOld = oldWidth > 0 && oldHeight > 0;
            const scaleFactor = hasOld ? (clipWidth / oldWidth) : 1;
            objects.forEach((obj) => {
                this.canvas.add(obj);
                if (hasOld) {
                    const relX = (obj.left - oldLeft) / oldWidth;
                    const relY = (obj.top - oldTop) / oldHeight;
                    obj.set({
                        left: centerX - clipWidth / 2 + relX * clipWidth,
                        top: centerY - clipHeight / 2 + relY * clipHeight,
                        scaleX: obj.scaleX * scaleFactor,
                        scaleY: obj.scaleY * scaleFactor,
                    });
                } else {
                    obj.set({
                        left: centerX,
                        top: centerY,
                        originX: obj.originX || "center",
                        originY: obj.originY || "center",
                    });
                }
                obj.setCoords();
            });

            this.canvas.clipPath = this.clipPath;
            this.canvas.renderAll();
        }

        alignObjects(direction) {
            if (!this.canvas || !this.clipPath) return;
            const activeObjects = this.canvas.getActiveObjects();
            if (!activeObjects.length) return;
            if (activeObjects.length === 1) {
                const bounds = this.clipPath.getBoundingRect(true);
                activeObjects.forEach((obj) => {
                    switch (direction) {
                        case "left":
                            obj.set({ left: bounds.left + obj.getScaledWidth() / 2 });
                            break;
                        case "centerH":
                            obj.set({ left: bounds.left + bounds.width / 2 });
                            break;
                        case "right":
                            obj.set({ left: bounds.left + bounds.width - obj.getScaledWidth() / 2 });
                            break;
                        case "top":
                            obj.set({ top: bounds.top + obj.getScaledHeight() / 2 });
                            break;
                        case "centerV":
                            obj.set({ top: bounds.top + bounds.height / 2 });
                            break;
                        case "bottom":
                            obj.set({ top: bounds.top + bounds.height - obj.getScaledHeight() / 2 });
                            break;
                    }
                    obj.setCoords();
                });
            } else {
                let minLeft = Infinity,
                    maxRight = -Infinity,
                    minTop = Infinity,
                    maxBottom = -Infinity;
                let totalCenterX = 0,
                    totalCenterY = 0;
                activeObjects.forEach((obj) => {
                    const bound = obj.getBoundingRect(true);
                    minLeft = Math.min(minLeft, bound.left);
                    maxRight = Math.max(maxRight, bound.left + bound.width);
                    minTop = Math.min(minTop, bound.top);
                    maxBottom = Math.max(maxBottom, bound.top + bound.height);
                    totalCenterX += bound.left + bound.width / 2;
                    totalCenterY += bound.top + bound.height / 2;
                });
                const avgCenterX = totalCenterX / activeObjects.length;
                const avgCenterY = totalCenterY / activeObjects.length;
                activeObjects.forEach((obj) => {
                    switch (direction) {
                        case "left":
                            obj.set({ left: minLeft + obj.getScaledWidth() / 2 });
                            break;
                        case "centerH":
                            obj.set({ left: avgCenterX });
                            break;
                        case "right":
                            obj.set({ left: maxRight - obj.getScaledWidth() / 2 });
                            break;
                        case "top":
                            obj.set({ top: minTop + obj.getScaledHeight() / 2 });
                            break;
                        case "centerV":
                            obj.set({ top: avgCenterY });
                            break;
                        case "bottom":
                            obj.set({ top: maxBottom - obj.getScaledHeight() / 2 });
                            break;
                    }
                    obj.setCoords();
                });
            }
            this.canvas.renderAll();
        }

        updateSize(size) {
            if (!size) {
                console.warn("Size is undefined, using default 10x7 Aluminum");
                size = "10x7 Aluminum";
            }
            state.mainSize = size;
            this.drawClipPath();
            this.updateCanvasSize();
            recalcPrice();
        }

        updateBackgroundColor(color) {
            if (!color) {
                console.warn("Background color is undefined, using default Gloss White");
                color = "Gloss White";
            }
            state.backgroundColor = color;
            if (this.clipPath) {
                this.clipPath.set({
                    fill: COLOR_MAPPINGS[color] || "#FFFFFF",
                });
                this.canvas.renderAll();
            } else {
                this.drawClipPath();
            }
            this.updateFinishButtonState();
        }

        updateBorderColor(color) {
            if (!color) {
                console.warn("Border color is undefined, using default Gloss Black");
                color = "Gloss Black";
            }
            state.borderColor = color;
            if (this.clipPath) {
                this.clipPath.set({
                    stroke: COLOR_MAPPINGS[color] || "#000000",
                });
                this.canvas.renderAll();
            } else {
                this.drawClipPath();
            }
            this.updateFinishButtonState();
        }

        updateText1(text) {
            if (!this.canvas || !this.clipPath) {
                this.drawClipPath();
            }
            const currentPosition = this.text1
                ? { left: this.text1.left, top: this.text1.top }
                : null;
            const currentFont = this.text1
                ? this.text1.fontFamily
                : state.font1.replaceAll(" ", "") || "Arial";
            const currentColor = this.text1
                ? this.text1.fill
                : COLOR_MAPPINGS[state.font_color1] || "#000000";

            if (this.text1) this.canvas.remove(this.text1);
            state.text1 = text;

            if (text.trim()) {
                const clipWidth = this.clipPath.width;
                const clipHeight = this.clipPath.height;
                const centerX = this.canvas.getWidth() / 2;
                const centerY = this.canvas.getHeight() / 2 - (this.text2 ? clipHeight * 0.2 : 0);
                const textObj = new fabric.Text(text, {
                    fontFamily: currentFont === "3rd Rail" ? "Third_Rail" : currentFont,
                    fill: currentColor,
                    originX: "center",
                    originY: "center",
                    left: currentPosition ? currentPosition.left : centerX,
                    top: currentPosition ? currentPosition.top : centerY,
                    fontSize: Math.min(clipWidth / Math.max(1, text.length) * 1.5, clipHeight * 0.4),
                    lineHeight: 1.2,
                    selectable: true,
                    evented: true,
                    textAlign: "center",
                    editable: false,
                    hasControls: true,
                    hasBorders: true,
                });

                let fontSize = textObj.fontSize;
                let textWidth = textObj.getScaledWidth();
                let textHeight = textObj.getScaledHeight();
                while ((textWidth > clipWidth * 0.9 || textHeight > clipHeight * 0.9) && fontSize > 10) {
                    fontSize *= 0.95;
                    textObj.set('fontSize', fontSize);
                    textWidth = textObj.getScaledWidth();
                    textHeight = textObj.getScaledHeight();
                }

                textObj.setCoords();
                this.canvas.add(textObj);
                this.canvas.bringForward(textObj);
                this.text1 = textObj;
                this.canvas.setActiveObject(textObj);
                this.canvas.renderAll();
            } else {
                this.text1 = null;
                this.canvas.renderAll();
            }
            this.updateFinishButtonState();
        }

        updateText2(text) {
            if (!this.canvas || !this.clipPath) {
                this.drawClipPath();
            }
            const currentPosition = this.text2
                ? { left: this.text2.left, top: this.text2.top }
                : null;
            const currentFont = this.text2
                ? this.text2.fontFamily
                : state.font2.replaceAll(" ", "") || "Arial";
            const currentColor = this.text2
                ? this.text2.fill
                : COLOR_MAPPINGS[state.font_color2] || "#000000";

            if (this.text2) this.canvas.remove(this.text2);
            state.text2 = text;

            if (text.trim()) {
                const clipWidth = this.clipPath.width;
                const clipHeight = this.clipPath.height;
                const centerX = this.canvas.getWidth() / 2;
                const centerY = this.canvas.getHeight() / 2 + (this.text1 ? clipHeight * 0.2 : 0);
                const textObj = new fabric.Text(text, {
                    fontFamily: currentFont === "3rd Rail" ? "Third_Rail" : currentFont,
                    fill: currentColor,
                    originX: "center",
                    originY: "center",
                    left: currentPosition ? currentPosition.left : centerX,
                    top: currentPosition ? currentPosition.top : centerY,
                    fontSize: Math.min(clipWidth / Math.max(1, text.length) * 1.5, clipHeight * 0.4),
                    lineHeight: 1.2,
                    selectable: true,
                    evented: true,
                    textAlign: "center",
                    editable: false,
                    hasControls: true,
                    hasBorders: true,
                });

                let fontSize = textObj.fontSize;
                let textWidth = textObj.getScaledWidth();
                let textHeight = textObj.getScaledHeight();
                while ((textWidth > clipWidth * 0.9 || textHeight > clipHeight * 0.9) && fontSize > 10) {
                    fontSize *= 0.95;
                    textObj.set('fontSize', fontSize);
                    textWidth = textObj.getScaledWidth();
                    textHeight = textObj.getScaledHeight();
                }

                textObj.setCoords();
                this.canvas.add(textObj);
                this.canvas.bringForward(textObj);
                this.text2 = textObj;
                this.canvas.setActiveObject(textObj);
                this.canvas.renderAll();
            } else {
                this.text2 = null;
                this.canvas.renderAll();
            }
            this.updateFinishButtonState();
        }

        updateFont1(font) {
            if (!font) {
                console.warn("Font is undefined, using default Arial");
                font = "Arial";
            }
            state.font1 = font;
            if (this.text1) {
                this.text1.set("fontFamily", font === "3rd Rail" ? "Third_Rail" : font.replaceAll(" ", ""));
                this.canvas.renderAll();
            }
        }

        updateFont2(font) {
            if (!font) {
                console.warn("Font is undefined, using default Arial");
                font = "Arial";
            }
            state.font2 = font;
            if (this.text2) {
                this.text2.set("fontFamily", font === "3rd Rail" ? "Third_Rail" : font.replaceAll(" ", ""));
                this.canvas.renderAll();
            }
        }

        updateFontColor1(color) {
            if (!color) {
                console.warn("Font color is undefined, using default Black");
                color = "Black";
            }
            state.font_color1 = color;
            if (this.text1) {
                this.text1.set("fill", COLOR_MAPPINGS[color] || "#000000");
                this.canvas.renderAll();
            }
            this.updateFinishButtonState();
        }

        updateFontColor2(color) {
            if (!color) {
                console.warn("Font color is undefined, using default Black");
                color = "Black";
            }
            state.font_color2 = color;
            if (this.text2) {
                this.text2.set("fill", COLOR_MAPPINGS[color] || "#000000");
                this.canvas.renderAll();
            }
            this.updateFinishButtonState();
        }

        async finishEditing() {
            if (!this.canvas || !this.clipPath) {
                this.showError("Please create a design before finishing.");
                return;
            }
            if (!this.hasContent()) {
                this.showError("Please add text or upload artwork before finishing.");
                return;
            }
            this.canvas.renderAll();
            try {
                const bounds = this.clipPath.getBoundingRect(true);
                const dataURL = this.canvas.toDataURL({
                    left: bounds.left,
                    top: bounds.top,
                    width: bounds.width,
                    height: bounds.height,
                    format: "png",
                    multiplier: 2,
                    enableRetinaScaling: true
                });
                const file = dataURLtoFile(dataURL, "edited-sign.png");
                state.artworkImage = file;
                const previewImage = document.getElementById("preview-image");
                if (previewImage) {
                    previewImage.src = dataURL;
                    previewImage.classList.remove("non-editable-image");
                }
                const designerTool = document.getElementById("designerTool");
                const previewBox = document.getElementById("preview-box");
                const mainVariants = document.getElementById("main-variants");
                const uploadArtbox = document.getElementById("upload-artbox");

                if (designerTool) {
                    designerTool.classList.remove("active");
                    enableBodyScroll();
                }
                if (previewBox) {
                    previewBox.style.display = "block";
                }
                if (mainVariants) {
                    if (state.artworkImage) {
                        mainVariants.classList.add("active");
                    } else {
                        mainVariants.classList.remove("active");
                    }
                }
                if (uploadArtbox) uploadArtbox.style.display = "none";
                const [widthInch, heightInch] = state.mainSize
                    .split("x")
                    .map((s) => s.trim().split(" ")[0]);
                document.getElementById("width-inch").textContent = `${widthInch}"`;
                document.getElementById("height-inch").textContent = `${heightInch}"`;
                previousSize = state.mainSize;
            } catch (err) {
                console.error("Error saving edited image:", err);
                this.showError("Failed to save edited image. Please try again.");
            }
        }

        handleRemoveAll() {
            if (this.canvas) {
                this.canvas.clear();
                this.canvas.clipPath = null;
                this.canvas.dispose();
            }
            this.clipPath = null;
            this.text1 = null;
            this.text2 = null;
            this.artwork = null;
            state.artworkImage = null;
            state.text1 = "";
            state.text2 = "";
            const uploadArtbox = document.getElementById("upload-artbox");
            const previewBox = document.getElementById("preview-box");
            const uploadArtwork = document.getElementById("upload-artwork");
            if (uploadArtbox) uploadArtbox.style.display = "block";
            if (previewBox) previewBox.style.display = "none";
            if (uploadArtwork) uploadArtwork.value = "";
            const designerTool = document.getElementById("designerTool");
            if (designerTool) {
                designerTool.classList.remove("active");
                enableBodyScroll();
            }
            const mainVariants = document.getElementById("main-variants");
            if (mainVariants) mainVariants.classList.remove("active");
            this.init();
            this.updateFinishButtonState();
        }

        showError(message) {
            const msgEl = document.getElementById("canvasMessage");
            if (msgEl) {
                msgEl.classList.remove("warning");
                msgEl.classList.add("error");
                msgEl.textContent = message;
                show(msgEl);
                setTimeout(() => hide(msgEl), 5000);
            }
        }

        showWarning(message) {
            const msgEl = document.getElementById("canvasMessage");
            if (msgEl) {
                msgEl.classList.remove("error");
                msgEl.classList.add("warning");
                msgEl.textContent = message;
                show(msgEl);
                setTimeout(() => hide(msgEl), 5000);
            }
        }

        setupArtworkUpload() {
        const artbox = document.getElementById("upload-artbox");
        const previewBox = document.getElementById("preview-box");
        const mainVariants = document.getElementById("main-variants");
        const deleteBannerImage = document.getElementById("delete-banner-image");
        const uploadArtwork = document.getElementById("upload-artwork");

        if (!artbox || !previewBox || !mainVariants || !deleteBannerImage) {
            console.error("Required elements for artwork upload are missing");
            return;
        }

        // Create file input if not present
        if (!uploadArtwork) {
            const fileInput = document.createElement("input");
            fileInput.type = "file";
            fileInput.id = "upload-artwork";
            fileInput.accept = ".jpg,.jpeg,.png,.svg,.webp,.pdf,.ai,.eps,.tiff";
            fileInput.style.display = "none";
            artbox.querySelector(".upload-file-box label").appendChild(fileInput);
        }

        const fileInput = document.getElementById("upload-artwork");
        if (!fileInput) return;

        fileInput.addEventListener("change", (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const allowedTypes = [
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/webp",
                "image/svg+xml",
                "application/pdf",
                "image/tiff",
                "application/postscript",
            ];
            const ext = file.name.split(".").pop().toLowerCase();
            const isNonEditable = ["pdf", "ai", "eps", "tiff"].includes(ext);

            if (!allowedTypes.includes(file.type) && !["ai", "eps"].includes(ext)) {
                this.showError("Please upload a valid image file (.jpg, .jpeg, .png, .svg, .webp, .pdf, .ai, .eps, .tiff)");
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                const img = document.getElementById("preview-image");
                if (isNonEditable) {
                    const FORMAT_ICONS = {
                        pdf: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/pdf-file.png",
                        ai: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/ai-file.png",
                        eps: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/eps-file.png",
                        tiff: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/tif-file.png",
                    };
                    img.src = FORMAT_ICONS[ext] || e.target.result;
                    previewBox.classList.add("non-editable-image");
                    document.getElementById("btnEditImage").style.display = "none";
                } else {
                    img.src = e.target.result;
                    previewBox.classList.remove("non-editable-image");
                    document.getElementById("btnEditImage").style.display = "";
                }
                artbox.style.display = "none";
                previewBox.style.display = "block";
                mainVariants.classList.add("active");
                state.artworkImage = file;
                const [widthInch, heightInch] = state.mainSize
                    .split("x")
                    .map((s) => s.trim().split(" ")[0]);
                document.getElementById("width-inch").textContent = `${widthInch}"`;
                document.getElementById("height-inch").textContent = `${heightInch}"`;
                previousSize = state.mainSize;
                this.updateFinishButtonState();

                if (!isNonEditable && this.canvas) {
                    fabric.Image.fromURL(
                        URL.createObjectURL(file),
                        (imgObj) => {
                            if (!this.canvas || !this.clipPath) return;
                            if (this.artwork) this.canvas.remove(this.artwork);
                            const clipWidth = this.clipPath.width;
                            const clipHeight = this.clipPath.height;
                            const scaleFactor = Math.min(
                                (clipWidth * 0.5) / imgObj.width,
                                (clipHeight * 0.5) / imgObj.height
                            );
                            const centerX = this.canvas.getWidth() / 2;
                            const centerY = this.canvas.getHeight() / 2;
                            imgObj.set({
                                scaleX: scaleFactor,
                                scaleY: scaleFactor,
                                originX: "center",
                                originY: "center",
                                left: centerX,
                                top: centerY,
                                selectable: true,
                                evented: true,
                                hasControls: true,
                                hasBorders: true,
                            });
                            imgObj.setCoords();
                            this.canvas.add(imgObj);
                            this.artwork = imgObj;
                            this.canvas.renderAll();
                            this.updateFinishButtonState();
                        },
                        { crossOrigin: "anonymous" }
                    );
                }
            };
            reader.onerror = () => {
                this.showError("Error reading file. Please try again.");
                state.artworkImage = null;
            };
            reader.readAsDataURL(file);
        });

        deleteBannerImage.addEventListener("click", () => {
            if (this.artwork) this.canvas.remove(this.artwork);
            this.artwork = null;
            state.artworkImage = null;
            artbox.style.display = "block";
            previewBox.style.display = "none";
            mainVariants.classList.remove("active");
            const previewImage = document.getElementById("preview-image");
            if (previewImage) previewImage.src = "";
            fileInput.value = "";
            this.canvas.renderAll();
            this.updateFinishButtonState();
        });
    }

    // End of MetalSignDesigner class
    }

    // =============================================
    // 13. INITIALIZE EVERYTHING
    // =============================================
    let designer = null;
    function initialize() {
        const inlineActions = document.querySelector(".inline-actions");
        if (inlineActions) {
            const snapToggle = document.createElement("label");
            snapToggle.className = "guides-toggle-switch";
            snapToggle.innerHTML = `
                <input type="checkbox" id="toggleSnap" checked />
                <span class="guides-slider"></span>
                <span class="guides-label-text">Enable Snapping</span>
            `;
            inlineActions.appendChild(snapToggle);
        }
        designer = new MetalSignDesigner();
        initDropdownDefaults();
        setupSizeSelection();
        handleTextInput1();
        handleTextInput2();
        setupApippaAddToCart();
        document.addEventListener("click", dropdownClickHandler);
        recalcPrice();
    }

    initialize();
});